import { render, staticRenderFns } from "./reta.vue?vue&type=template&id=266a5bce&scoped=true"
import script from "./reta.vue?vue&type=script&lang=js"
export * from "./reta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a5bce",
  null
  
)

export default component.exports